const origin = location.origin;
export const BASE_API = String.prototype.replace.call(process.env.BASE_API, /#/, origin);
import request from './request/request.js';
// export const BASE_API = 'https://devyz.yunzhengshou.com/service';
export { previewPageOffice } from './previewOffice';
// 判断格式
export function getImgSrcType(fileName, suffix) {
  const reg1 = /\.(xlsx|xls)$/;
  const reg2 = /\.(docx|doc)$/;
  const reg3 = /\.(pdf)$/;
  const reg4 = /\.(gif|jpg|pic|png|dwg|dws|dwt|dxf|jpeg|bmp|tiff)$/;
  const reg5 = /\.(mp4|rmvb|flv|mpeg|avi)$/;
  let name = fileName + '.' + suffix;
  if (reg1.test(name)) {
    return 'xls';
  }
  if (reg2.test(name)) {
    return 'doc';
  }
  if (reg3.test(name)) {
    return 'pdf';
  }
  if (reg4.test(name)) {
    return 'jpg';
  }
  if (reg5.test(name)) {
    return 'video';
  }
}
export function decodeURI(url) {
  // const Reg = /^\/[w]{1,}/;
  // if (Reg.test(url)) {
  return BASE_API + url;
  // }
}
/**
* 获取 blob
* @param  {String} url 目标文件地址
* @return {Promise}
*/
export function getBlob(url, data, options = {}) {
  const method = options.method || 'GET';
  return request({
    url,
    method,
    data,
    responseType: 'blob'
  });
}
// 获取图片的下标
export function getImageIndex(images, imgPreviewURL) {
  // var index = 0;
  for (let i = 0; i < images.length; i++) {
    if (images[i] === imgPreviewURL) {
      return i;
      // break;
    }
  }
  // return index;
}
/**
* @param {any} data 要存储的数据
*@param {String} key 要存储数据的key
*descrition: 存储sessionStorage的数据
*/
export function setSession(key, data) {
  if (arguments.length < 2) {
    throw new SyntaxError('must provide key && data')
  }
  if (typeof key !== 'string' || key === '') {
    throw new TypeError('setSession: key must be a valid string key')
  }
  const json = JSON.stringify(data)
  window.sessionStorage.setItem(key, json)
}

/**
* 根据传入的key 查询sessionStorage的数据
* @param {查询的key} key
*/
export function getSession(key) {
  if (typeof key !== 'string' || key === '') {
    return 'invalid key'
  }
  const data = window.sessionStorage.getItem(key)
  try {
    return JSON.parse(data)
  } catch (e) {
    return data
  }
}

/**
*@param {String} key 删除对应的value
*descrition: 删除sessionStorage的数据
*/

export function removeSession(key) {
  if (typeof key !== 'string' || key === '') {
    throw new TypeError('setSession: key must be a valid string key')
  }
  return window.sessionStorage.removeItem(key)
}
/**
 * @param {any} source 需要深度复制的数据源
 * descrition: 深度复制数据
 */
export function deepCopyData(source) {
  const json = JSON.stringify(source);
  try {
    return JSON.parse(json);
  } catch (e) {
    return json;
  }
}
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
export function isUndef(v) {
  return v === undefined || v === null || v === '';
}
/**
 * @param {Object} target  // 要被混入数据的对象
 */
export const merge = function (target) {
  const args = Array.from(arguments).slice(1);
  for (let i = 0, j = args.length; i < j; i++) {
    let source = args[i] || {};
    for (let prop in source) {
      if (hasOwn(source, prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
};
/**
 * 将数组转成树形数据
 * @param {原始数据} arrList
 * @param {配置项} options
 */
export function convertArrToTree(arrList, options = {}) {
  const top = [];
  const sub = [];
  const hasMap = {};
  const rootId = options.rootId === undefined ? '0' : options.rootId;
  const children = options.children || 'children';
  const parentId = options.parentId || 'parentId';
  const key = options.id || 'id';
  for (let node of arrList) {
    node[children] = [];
    if (node[parentId] === rootId) {
      top.push(node);
    } else {
      sub.push(node);
    }
    hasMap[node[key]] = node;
  }

  for (let node of sub) {
    let parent = hasMap[node[parentId]] || {
      [children]: []
    };
    parent[children].push(node);
  }

  return top;
}

// 深拷贝
export function deepCopy(obj) {
  if (typeof obj !== 'object' || obj == null) {
    return obj;
  }
  let resultObj;
  if (obj instanceof Array) {
    resultObj = [];
  } else {
    resultObj = {};
  }
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      resultObj[key] = deepCopy(obj[key]);
    }
  }
  return resultObj;
}



// WEBPACK FOOTER //
// ./src/untils/index.js